import script from "./ModalError.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalError.vue?vue&type=script&lang=ts&setup=true"

import "./ModalError.vue?vue&type=style&index=0&id=35273b79&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35273b79"]])

export default __exports__